import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MasterConstants } from '../../../common/constants/master-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../services/common/common.service';
import { OtiService } from '../../../services/oti/oti.service';
import { CppService } from '../../../services/cpp/cpp.service';
import { DatePipe } from '@angular/common';
import { OtiOrderDetailSliderModelService } from './oti-order-detail-slider-model.service';
import * as $ from 'jquery';
import pdfMake from 'pdfmake/build/pdfmake';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-oti-order-detail',
  templateUrl: './oti-order-detail.component.html',
  styleUrls: ['./oti-order-detail.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class OtiOrderDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  salesOrderNumber: string;
  isBackToCppOrderSummaryRequired: any;
  webOrderNumber: any;
  headerDetails: any = {};
  orderSplitDetails: any = [];
  pdfDataObject: any;
  MobileStatusList: any = [];
  headerCompany = MasterConstants.US_COMPANYCODE;
  status = false;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  IsMobile = false;
  chevronSteps: any;
  orderType: string;
  displayedColumns: string[] = ['product', 'detail', 'quantity', 'orderUOM', 'packageSize', 'tracking'];
  displayedFooterColumns: string[] = this.displayedColumns;
  constructor(private router: Router,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private otiService: OtiService,
    private cppService: CppService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private otiOrderDetailSliderModelService: OtiOrderDetailSliderModelService) { }

  ngOnInit() {
    if (this.isMobile) {
      this.IsMobile = true;
    }

    this.subscription.push(this.otiOrderDetailSliderModelService.orderNumber.subscribe(x => {
      this.salesOrderNumber = x;
    }));
    this.subscription.push(this.otiOrderDetailSliderModelService.orderType.subscribe(x => {
      this.orderType = x;
    }));
    
    this.subscription.push(this.activatedRoute.queryParams.subscribe(params => {
      this.isBackToCppOrderSummaryRequired = params['backToCppOrderSummary'];
      this.webOrderNumber = params['webOrderNumber'];
    }));

    this.getOtiSummaryOrders();
  }

  toggleArrow(element) {
    element.chevronFlag = !element.chevronFlag;
  }

  // get list of orders based on filtter
  getOtiSummaryOrders() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.otiService.getOTISummary(this.salesOrderNumber, this.orderType).subscribe((result) => {
      const statusItem = result.otiOrderSplitDetails[0].otiStatusList.find(x => x.chevronStatus === result.otiOrderSplitDetails[0].orderStatus);
      if (statusItem !== null && statusItem !== undefined) {
        if (statusItem.sequenceNo == 1) {
          this.MobileStatusList.push(statusItem);
          this.MobileStatusList.push(result.otiOrderSplitDetails[0].otiStatusList[statusItem.sequenceNo]);
          this.chevronSteps = 6;
        } else if (statusItem.sequenceNo == (result.otiOrderSplitDetails[0].otiStatusList.length)) {
          this.MobileStatusList.push(result.otiOrderSplitDetails[0].otiStatusList[statusItem.sequenceNo - 2]);
          this.MobileStatusList.push(statusItem);
        }
        else {
          this.MobileStatusList.push(result.otiOrderSplitDetails[0].otiStatusList[statusItem.sequenceNo - 2]);
          this.MobileStatusList.push(statusItem);
          this.MobileStatusList.push(result.otiOrderSplitDetails[0].otiStatusList[statusItem.sequenceNo]);
          this.chevronSteps = 8 - statusItem.sequenceNo;
        }
      }

      this.pdfDataObject = result;
      this.headerDetails = result.headerDetails;
      this.orderSplitDetails = result.otiOrderSplitDetails;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSummaryTableHeight();
  }

  // set account table height
  setSummaryTableHeight() {
    const tableHeight = window.innerHeight - 85;
    // console.log("tbaleHeight", tableHeight);
    $('.otiMainWrapper').css('height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setSummaryTableHeight();
  }

  // Navigate  to CPP landing page
  backToCPPSummaryPage() {
    this.cppService.webOrderNumberAndSplitId = this.webOrderNumber + '~' + '~' + '~CPPLanding';
    this.router.navigate(['/cpp/cpp-order-summary']);
  }

  backToOTILandingPage() {
    this.localStorageService.set(MasterConstants.OTI_BACK_TO_ORDER, true);
    this.otiOrderDetailSliderModelService.otiOrderDetailClose();
  }

  // Generate Pdf report
  generatePdf() {
    if (this.headerDetails && this.orderSplitDetails) {
      const documentDefinition = this.getDocumentDefinition();
      pdfMake.createPdf(documentDefinition).download('OTI_Order_' + this.salesOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
    } else {
      this.toastrService.error('No data available for Sales Order Number #' + this.salesOrderNumber);
    }
  }

  // PDF document defination
  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM/dd/yyyy');
    const orderCreateDate = this.headerDetails.orderDate;
    let displayWith = [];
    let columnList = [];
    let valueList = [];

    // ShipTo Account available
    if (!this.headerDetails.soldTo_Address && !this.headerDetails.deliverTo_Address && !this.headerDetails.ship_From) {
      displayWith = ['100%'];
      columnList = [{ text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true }];
      valueList = [
        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,
      ];
    }
    // ShipTo & DeliverTo  Account available
    else if (!this.headerDetails.soldTo_Address && this.headerDetails.deliverTo_Address && !this.headerDetails.ship_From) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true }, { text: 'DELIVER TO: ' + this.headerDetails.deliverTo_Address.deliverToAccountNumber, bold: true }];
      valueList = [
        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,

        this.headerDetails.deliverTo_Address.deliverToAccountName + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToAddress + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToCity + ', ' + this.headerDetails.deliverTo_Address.deliverToState + ' ' + this.headerDetails.deliverTo_Address.deliverToZipCode + ' \n',

      ];
    }
    // ShipTo & SoldTo Account available
    else if (this.headerDetails.soldTo_Address && !this.headerDetails.deliverTo_Address && !this.headerDetails.ship_From) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SOLD TO: ' + this.headerDetails.soldTo_Address.soldToAccountNumber, bold: true }, { text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true }];
      valueList = [
        this.headerDetails.soldTo_Address.soldToAccountName + ' \n' +
        this.headerDetails.soldTo_Address.soldToAddress1 + ' \n' +
        (this.headerDetails.soldTo_Address.soldToAddress2 == '' ? '' : this.headerDetails.soldTo_Address.soldToAddress2 + ' \n') +
        this.headerDetails.soldTo_Address.soldToCity + ', ' + this.headerDetails.soldTo_Address.soldToState + ' ' + this.headerDetails.soldTo_Address.soldToZipCode + ' \n',

        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,
      ];
    }
    // ShipTo & shipFrom Account available
    else if (!this.headerDetails.soldTo_Address && !this.headerDetails.deliverTo_Address && this.headerDetails.ship_From) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true }, { text: 'SHIP FROM: ' + this.headerDetails.ship_From.sfAccount, bold: true }];
      valueList = [
        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,

        this.headerDetails.ship_From.sfCity + ', ' + this.headerDetails.ship_From.sfState,
      ];
    }
    // ShipTo & DeliverTo & shipFrom Account available
    else if (!this.headerDetails.soldTo_Address && this.headerDetails.deliverTo_Address && this.headerDetails.ship_From) {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true }, { text: 'DELIVER TO: ' + this.headerDetails.deliverTo_Address.deliverToAccountNumber, bold: true }, { text: 'SHIP FROM: ' + this.headerDetails.ship_From.sfAccount, bold: true }];
      valueList = [
        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,

        this.headerDetails.deliverTo_Address.deliverToAccountName + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToAddress + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToCity + ', ' + this.headerDetails.deliverTo_Address.deliverToState + ' ' + this.headerDetails.deliverTo_Address.deliverToZipCode + ' \n',

        this.headerDetails.ship_From.sfCity + ', ' + this.headerDetails.ship_From.sfState,
      ];
    }
    // ShipTo & SoldTo & shipFrom Account available
    else if (this.headerDetails.soldTo_Address && !this.headerDetails.deliverTo_Address && this.headerDetails.ship_From) {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO: ' + this.headerDetails.soldTo_Address.soldToAccountNumber, bold: true }, { text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true }, { text: 'SHIP FROM: ' + this.headerDetails.ship_From.sfAccount, bold: true }];
      valueList = [
        this.headerDetails.soldTo_Address.soldToAccountName + ' \n' +
        this.headerDetails.soldTo_Address.soldToAddress1 + ' \n' +
        (this.headerDetails.soldTo_Address.soldToAddress2 == '' ? '' : this.headerDetails.soldTo_Address.soldToAddress2 + ' \n') +
        this.headerDetails.soldTo_Address.soldToCity + ', ' + this.headerDetails.soldTo_Address.soldToState + ' ' + this.headerDetails.soldTo_Address.soldToZipCode + ' \n',

        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,

        this.headerDetails.ship_From.sfCity + ', ' + this.headerDetails.ship_From.sfState,
      ];
    }
    // ShipTo, SoldTo & DeliverTo Account available
    else if (this.headerDetails.soldTo_Address && this.headerDetails.deliverTo_Address && !this.headerDetails.ship_From) {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO: ' + this.headerDetails.soldTo_Address.soldToAccountNumber, bold: true },
      { text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true },
      { text: 'DELIVER TO: ' + this.headerDetails.deliverTo_Address.deliverToAccountNumber, bold: true }
      ];
      valueList = [
        this.headerDetails.soldTo_Address.soldToAccountName + ' \n' +
        this.headerDetails.soldTo_Address.soldToAddress1 + ' \n' +
        (this.headerDetails.soldTo_Address.soldToAddress2 == '' ? '' : this.headerDetails.soldTo_Address.soldToAddress2 + ' \n') +
        this.headerDetails.soldTo_Address.soldToCity + ', ' + this.headerDetails.soldTo_Address.soldToState + ' ' + this.headerDetails.soldTo_Address.soldToZipCode + ' \n',

        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,

        this.headerDetails.deliverTo_Address.deliverToAccountName + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToAddress + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToCity + ', ' + this.headerDetails.deliverTo_Address.deliverToState + ' ' + this.headerDetails.deliverTo_Address.deliverToZipCode + ' \n',
      ];
    }
    // ShipTo, SoldTo & DeliverTo & shipFrom Account available
    else {
      displayWith = ['25%', '25%', '25%', '25%'];
      columnList = [{ text: 'SOLD TO: ' + this.headerDetails.soldTo_Address.soldToAccountNumber, bold: true },
      { text: 'SHIP TO: ' + this.headerDetails.staAccountNumber, bold: true },
      { text: 'DELIVER TO: ' + this.headerDetails.deliverTo_Address.deliverToAccountNumber, bold: true },
      { text: 'SHIP FROM: ' + this.headerDetails.ship_From.sfAccount, bold: true }
      ];
      valueList = [
        this.headerDetails.soldTo_Address.soldToAccountName + ' \n' +
        this.headerDetails.soldTo_Address.soldToAddress1 + ' \n' +
        (this.headerDetails.soldTo_Address.soldToAddress2 == '' ? '' : this.headerDetails.soldTo_Address.soldToAddress2 + ' \n') +
        this.headerDetails.soldTo_Address.soldToCity + ', ' + this.headerDetails.soldTo_Address.soldToState + ' ' + this.headerDetails.soldTo_Address.soldToZipCode + ' \n',

        this.headerDetails.staAccountName + ' \n' +
        this.headerDetails.staAddress + ' \n' +
        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,

        this.headerDetails.deliverTo_Address.deliverToAccountName + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToAddress + ' \n' +
        this.headerDetails.deliverTo_Address.deliverToCity + ', ' + this.headerDetails.deliverTo_Address.deliverToState + ' ' + this.headerDetails.deliverTo_Address.deliverToZipCode + ' \n',

        this.headerDetails.ship_From.sfCity + ', ' + this.headerDetails.ship_From.sfState,
      ];
    }

    // if (this.headerDetails.staAccountName) {
    //  displayWith = ['100%'];
    //  columnList = [{ text: 'SHIP TO:' }];
    //  valueList = [
    //    {
    //      text:
    //        this.headerDetails.staAccountName + ' \n' +
    //        this.headerDetails.staAddress + ' \n' +
    //        this.headerDetails.staCity + ', ' + this.headerDetails.staState + ' ' + this.headerDetails.staZipCode,
    //      bold: true
    //    }

    //  ];
    // }

    let headerTable;
    if (this.headerDetails.isOrderTakenByEmployee) {
      headerTable = {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [{ text: 'ORDER #:' }, { text: this.salesOrderNumber, bold: true }
            , { text: 'REQUESTED DELIVERY DATE:' }, { text: this.datePipe.transform(this.headerDetails.requestedDeliveryDate, 'MM/dd/yyyy'), bold: true }],
          [{ text: 'ORDER DATE:' }, { text: this.datePipe.transform(this.headerDetails.orderDate, 'MM/dd/yyyy'), bold: true }
            , { text: 'ORDER TYPE:' }, { text: this.headerDetails.orderType, bold: true }],
          [{ text: 'CUSTOMER PO#:' }, { text: this.headerDetails.custPONumber, bold: true }
            , { text: 'ORDER METHOD:' }, { text: this.headerDetails.orderMethod, bold: true }],
          [{ text: '' }, { text: '', bold: true }
            , { text: 'ORDER STATUS:' }, { text: this.headerDetails.orderStatus, bold: true }],
        ]
      };
    } else {
      headerTable = {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [{ text: 'ORDER #:' }, { text: this.salesOrderNumber, bold: true }
            , { text: 'REQUESTED DELIVERY DATE:' }, { text: this.datePipe.transform(this.headerDetails.requestedDeliveryDate, 'MM/dd/yyyy'), bold: true }],
          [{ text: 'ORDER DATE:' }, { text: this.datePipe.transform(this.headerDetails.orderDate, 'MM/dd/yyyy'), bold: true }
            , { text: 'ORDER TYPE:' }, { text: this.headerDetails.orderType, bold: true }],
          [{ text: 'PLACED BY:' }, { text: this.headerDetails.placedBy, bold: true }
            , { text: 'ORDER METHOD:' }, { text: this.headerDetails.orderMethod, bold: true }],
          [{ text: 'CUSTOMER PO#:' }, { text: this.headerDetails.custPONumber, bold: true }
            , { text: 'ORDER STATUS:' }, { text: this.headerDetails.orderStatus, bold: true }],
        ]
      };
    }

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          image: 'data:image/png;base64,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',
          width: 102,
          height: 37,
          alignment: 'left',
        },
        {
          table: headerTable,
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },

        this.getContractPdfObject(this.orderSplitDetails),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nIf you have any questions regarding these changes, contact WinField United Customer Service, 1-855-494-6343'],
            ]
          },
          layout: 'noBorders'
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        }
      }
    };

    return pdfHTML;
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    const tblObject = [];
    let colum = [];
    splitDetails.forEach(obj => {
      const orderDetails = obj.productDetail;
      if (obj.invoiceNumber.toString() == '0' && obj.bolId == '') {
        colum = [
          {
            text: 'Status Tracker: ' + obj.orderStatus.toString(),
            alignment: 'left',
          },
          {
            text: '    Terms: ' + obj.paymentTerm.toString(),
            alignment: 'left',
          }];
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['50%', '50%'],
            marginTop: 10,
            marginBottom: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];

        tblObject.push(tblHeader);
      }
      else if (obj.invoiceNumber.toString() == '0' && obj.bolId != '') {
        colum = [{
          text: 'BOL#: ' + (obj.bolId == '-' ? '' : obj.bolId).toString().replace(/\s+/g, ' '),
          alignment: 'left',
        },
        {
          text: 'Status Tracker: ' + obj.orderStatus.toString().replace(/\s+/g, ' '),
          alignment: 'left',
        },
        {
          text: '    Terms: ' + obj.paymentTerm.toString().replace(/\s+/g, ' '),
          alignment: 'left',
        }];
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['33%', '33%', '33%'],
            marginTop: 10,
            marginBottom: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];

        tblObject.push(tblHeader);
      }
      else if (obj.invoiceNumber.toString() != '0' && obj.bolId == '') {
        colum = [
          {
            text: 'Status Tracker: ' + obj.orderStatus.toString().replace(/\s+/g, ' '),
            alignment: 'left',
          },
          {
            text: '    Terms: ' + obj.paymentTerm.toString().replace(/\s+/g, ' '),
            alignment: 'left',
          },
          {
            text: 'Invoice#: ' + obj.invoiceNumber.toString().replace(/\s+/g, ' '),
            alignment: 'right',
          }];
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['33%', '33%', '33%'],
            marginTop: 10,
            marginBottom: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];

        tblObject.push(tblHeader);
      }
      else {
        colum = [{
          text: 'BOL#: ' + (obj.bolId == '-' ? '' : obj.bolId).toString().replace(/\s+/g, ' '),
          alignment: 'left',
        },
        {
          text: 'Status Tracker: ' + obj.orderStatus.toString().replace(/\s+/g, ' '),
          alignment: 'left',
        },
        {
          text: '    Terms: ' + obj.paymentTerm.toString().replace(/\s+/g, ' '),
          alignment: 'left',
        },
        {
          text: 'Invoice#: ' + obj.invoiceNumber.toString().replace(/\s+/g, ' '),
          alignment: 'right',
        }];
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['25%', '25%', '25%', '25%'],
            marginTop: 10,
            marginBottom: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];

        tblObject.push(tblHeader);
      }

      const tbl = {
        table: {
          widths: ['45%', '15%', '15%', '25%'],
          color: '#0b3f54',
          body: [
            [{
              text: 'Product',
              style: 'tableHeader'
            },
            {
              text: 'Ordered Quantity',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Ordering UOM',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Package Size',
              style: 'tableHeader', alignment: 'center'
            },

            ],
            ...orderDetails.map(ordData => [
              ((ordData.vendorName) ? (ordData.vendorName + ' \n' + ordData.productName) : '' + ordData.productName),
              { text: ordData.orderedQuantity.toFixed(4), alignment: 'center' },
              { text: ordData.orderUOM, alignment: 'center' },
              { text: ordData.packageSize, alignment: 'center' },
            ])
          ]
        },
        style: 'tablefont',
      };
      tblObject.push(tbl);
    });

    return tblObject;
  }


  openShipmentTrackingURL(url) {
    window.open(url, '_blank');
  }
  // Show or Hide Product detail
  showProductDetails(item) {
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }
}
